export const STYLES = ["Woodgrain", "Solid colour", "Stone look"];

const FAMILIES = [
  [/oak|walnut|timber|wood|leather/, "Timber & leather"], [/black/, "Black"], [/brass|gold/, "Brass & gold"], [/nickel/, "Nickel"],
  [/chrome|silver|stainless|alumin/, "Chrome & steel"], [/bronze/, "Bronze"], [/copper/, "Copper"],
  [/gunmetal|charcoal|pewter|graphite|grey|gray|tin\b/, "Gunmetal & grey"], [/white/, "White"],
];

const finishFamilies = (i) => {
  const s = (i?.specs || []).find((x) => /^(finish|colour|color)$/i.test(x.label));
  if (!s) return [];
  const parts = s.value.toLowerCase().split(/[,/]/).map((v) => v.trim()).filter(Boolean);
  return [...new Set(parts.map((p) => FAMILIES.find(([re]) => re.test(p))?.[1]).filter(Boolean))];
};

export const itemFinishes = (i) => {
  if (i?.category === "hardware") return finishFamilies(i);
  const s = (i?.specs || []).find((x) => x.label === "Available finishes");
  return s ? s.value.split(",").map((v) => v.trim()).filter((v) => v && v !== "See supplier") : [];
};

const chip = (on) =>
  `shrink-0 inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm border transition-colors duration-300 ${on ? "bg-[#F5F3EF] text-[#0D0D11] border-[#F5F3EF]" : "border-[#D4AF37]/25 text-[#A09E97] hover:text-[#F5F3EF]"}`;

const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export const FilterRow = ({ label, id, options, value, pool, field, match, onChange }) => (
  <section className="mx-auto max-w-[1440px] px-5 sm:px-10 flex items-center gap-3 overflow-x-auto" data-testid={`${id}-filter`}>
    <span className="shrink-0 w-20 font-mono-j text-[11px] uppercase tracking-[0.25em] text-[#C5A059]">{label}</span>
    <button onClick={() => onChange("")} data-testid={`${id}-filter-all`} className={chip(!value)}>
      All <span className="text-xs opacity-70">{pool.length}</span>
    </button>
    {options.map((o) => (
      <button key={o} onClick={() => onChange(o)} data-testid={`${id}-filter-${slugify(o)}`} className={chip(value === o)}>
        {o} <span className="text-xs opacity-70">{pool.filter((i) => (match ? match(i, o) : i[field] === o)).length}</span>
      </button>
    ))}
  </section>
);
